import React, { useState } from 'react';
import { Button } from './ui/Button';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="flex justify-between items-center h-20" data-id="element-184">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" data-id="element-185">
            <div className="w-8 h-8 bg-blue-950 rounded-lg flex items-center justify-center" data-id="element-186">
              <span className="text-white font-bold text-xl" data-id="element-187">S</span>
            </div>
            <span className="font-sans text-xl font-bold tracking-tight text-gray-900" data-id="element-188">
              ScanMind
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-189">
            <NavItem label="Продукт" hasDropdown data-id="element-190" />
            <NavItem label="Решения" hasDropdown data-id="element-191" />
            <NavItem label="Ресурсы" hasDropdown data-id="element-192" />
            <a href="#" className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors" data-id="element-193">
              Цены
            </a>
            <a href="#" className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors" data-id="element-194">
              Компания
            </a>
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-195">
            <Button variant="ghost" size="sm" className="text-gray-500" data-id="element-196">
              Войти
            </Button>
            <Button variant="secondary" size="sm" data-id="element-197">
              Попробовать
            </Button>
            <Button variant="primary" size="sm" data-id="element-198">
              Запросить демо
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-199">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-500 hover:text-gray-900 focus:outline-none" data-id="element-200">
              {isOpen ? <XIcon className="h-6 w-6" data-id="element-201" /> : <MenuIcon className="h-6 w-6" data-id="element-202" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-t border-gray-200 absolute w-full" data-id="element-203">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-204">
            <MobileNavItem label="Продукт" data-id="element-205" />
            <MobileNavItem label="Решения" data-id="element-206" />
            <MobileNavItem label="Ресурсы" data-id="element-207" />
            <MobileNavItem label="Цены" data-id="element-208" />
            <MobileNavItem label="Компания" data-id="element-209" />
            <div className="pt-4 space-y-3" data-id="element-210">
              <Button variant="ghost" className="w-full justify-start" data-id="element-211">
                Войти
              </Button>
              <Button variant="secondary" className="w-full justify-center" data-id="element-212">
                Попробовать
              </Button>
              <Button variant="primary" className="w-full justify-center" data-id="element-213">
                Запросить демо
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}
function NavItem({
  label,
  hasDropdown
}: {
  label: string;
  hasDropdown?: boolean;
}) {
  return <div className="relative group cursor-pointer flex items-center gap-1" data-id="element-214">
      <span className="text-sm font-medium text-gray-500 group-hover:text-gray-900 transition-colors" data-id="element-215">
        {label}
      </span>
      {hasDropdown && <ChevronDownIcon className="w-3 h-3 text-gray-400 group-hover:text-gray-900 transition-colors" data-id="element-216" />}
    </div>;
}
function MobileNavItem({
  label
}: {
  label: string;
}) {
  return <a href="#" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-md" data-id="element-217">
      {label}
    </a>;
}